import Sidebar from "../components/Sidebar";
import MobileHeader from "../components/MobileHeader";
import ProtectDashboardRoute from "../components/ProtectDashboardRoute";
import { Globe2, Flag, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function BuySmsRoutePage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-gray-50">
      <ProtectDashboardRoute />
      <Sidebar />
      <MobileHeader />

      {/* Main Content */}
      <div className="flex-1 flex flex-col mt-[60px] lg:mt-0">
        <main className="flex-1 flex items-center justify-center p-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 max-w-2xl w-full">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-8">
              Choose SMS Notification Route
            </h2>

            <div className="grid md:grid-cols-2 gap-6">
              {/* US Route */}
              <div
                onClick={() => navigate("/dashboard/Recieve/US/SMS")}
                className="cursor-pointer bg-gray-50 hover:bg-blue-50 border border-gray-200 hover:border-blue-400 rounded-2xl p-6 text-center transition shadow-sm hover:shadow-md"
              >
                <Flag className="w-12 h-12 text-[#007AFF] mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  US Route
                </h3>
                <p className="text-gray-600 mb-3">
                  SMS verification for U.S. numbers only premium route with high
                  delivery success.
                </p>
                <div className="flex items-center justify-center text-[#007AFF] font-semibold gap-2">
                  Select Route <ArrowRight className="w-4 h-4" />
                </div>
              </div>

              {/* Dotti Global */}
              <div
                onClick={() => navigate("/dashboard/Recieve/Global/SMS")}
                className="cursor-pointer bg-gray-50 hover:bg-blue-50 border border-gray-200 hover:border-blue-400 rounded-2xl p-6 text-center transition shadow-sm hover:shadow-md"
              >
                <Globe2 className="w-12 h-12 text-green-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  Dotti Global
                </h3>
                <p className="text-gray-600 mb-3">
                  Works for all countries — reliable and affordable global
                  delivery option.
                </p>
                <div className="flex items-center justify-center text-green-600 font-semibold gap-2">
                  Select Route <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
